export default __webpack_public_path__ + "static/media/whatsapp-icon.69cf3695.svg";